import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { H2 } from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import RoundIcon from 'components/common/RoundIcon/RoundIcon'
import { dynamicDataAttribute } from 'helpers/utils'

const Heading = ({ asset, className, title, subhead, targetId, ...props }) =>
  <HeadWrapper className={ className } { ...props }>
    <TitleWrapper>
      { asset &&
        <Logo { ...dynamicDataAttribute(`section-${targetId}-icon`) } medium inline alt="" asset={ asset } />
      }
      <Title id={ targetId } data-at-appointment-headline headline headline_narrow inline noMargin tabIndex="-1">{ title }</Title>
    </TitleWrapper>
    <SubHead data-at-appointment-subhead data-non-empty>{ subhead }</SubHead>
  </HeadWrapper>

Heading.propTypes = {
  asset: PropTypes.string,
  className: PropTypes.string,
  subhead: PropTypes.string,
  targetId: PropTypes.string,
  title: PropTypes.string
}

export default Heading

const HeadWrapper = styled.div`
  text-align: center;
  ${Mixin.responsive('margin-bottom', '40px', '20px')}
`

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`

const Logo = styled(RoundIcon)`
  display: block;
  height: 2.4em;
  width: 2.4em;
  ${Mixin.responsive('margin-right', '15px', '10px')}

  img {
    height: 1.9em;
    width: 1.9em;
  }
`

const Title = styled(H2)`
  ${Media.mobile`
    font-size: 19px;
    margin-top: 8px;
  `}
`

const SubHead = styled.div`
  margin: 15px 0 0;
  line-height: 22px;
  color: ${Theme.colors.dark_grey};
`
